export default {
	cookie_expires: 10 * 365,
	AUTH_URL: 'https://api00.uflycloud.com:13149/gateway/auth/',
	COURSE_URL: 'https://api00.uflycloud.com:13149/gateway/course/',
	MIN_URL: 'https://api00.uflycloud.com/'
}